module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/icons/search-252aa17268d109305b6fdf2d59c31327.svg&quot;;"